import {
  titleUI,
  textUI,
} from 'platform/forms-system/src/js/web-component-patterns';
import set from 'platform/utilities/data/set';
import { FULL_SCHEMA } from '../../../utils/imports';
import content from '../../../locales/en/content.json';

const TITLE_TEXT = content['vet-info--mothers-maiden-name-title'];
const INPUT_LABEL = content['vet-info--mothers-maiden-name-label'];

const { mothersMaidenName } = FULL_SCHEMA.properties;

export default {
  uiSchema: {
    ...titleUI(TITLE_TEXT),
    mothersMaidenName: textUI(INPUT_LABEL),
  },
  schema: {
    type: 'object',
    properties: {
      mothersMaidenName: set('maxLength', 35, mothersMaidenName),
    },
  },
};
